module.exports = __webpack_public_path__ + "img/logo-amazeballs.dc6cbc57.jpeg";